import { computed } from 'vue'

import {
  VolleyballEventStatusId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import SidesSwitchOverlay from '@mobile/views/Relation/Shared/SidesSwitchOverlay/SidesSwitchOverlay.vue'

/* eslint-disable-next-line @typescript-eslint/explicit-function-return-type */
export function usePitchOverlays() {
  const { probableIncidents, probableEvent } = useEventInjections()

  const overlayComponents = computed(() => {
    return [
      {
        component: SidesSwitchOverlay,
        isVisible: !probableIncidents.value.find(
          (incident) =>
            incident.incident_id === VolleyballIncidentId.MatchAboutToStart,
        ),
        props: { incidentId: VolleyballIncidentId.MatchAboutToStart },
      },
      {
        component: SidesSwitchOverlay,
        isVisible:
          probableEvent.value.status_id === VolleyballEventStatusId.NotStarted,
        props: { incidentId: VolleyballIncidentId.FirstSetStarted },
      },
      {
        component: SidesSwitchOverlay,
        isVisible:
          probableEvent.value.status_id ===
          VolleyballEventStatusId.BreakAfterFirstSet,
        props: { incidentId: VolleyballIncidentId.SecondSetStarted },
      },
      {
        component: SidesSwitchOverlay,
        isVisible:
          probableEvent.value.status_id ===
          VolleyballEventStatusId.BreakAfterSecondSet,
        props: { incidentId: VolleyballIncidentId.ThirdSetStarted },
      },
      {
        component: SidesSwitchOverlay,
        isVisible:
          probableEvent.value.status_id ===
          VolleyballEventStatusId.BreakAfterThirdSet,
        props: { incidentId: VolleyballIncidentId.FourthSetStarted },
      },
      {
        component: SidesSwitchOverlay,
        isVisible:
          probableEvent.value.status_id ===
          VolleyballEventStatusId.BreakAfterFourthSet,
        props: { incidentId: VolleyballIncidentId.FifthSetStarted },
      },
    ]
  })

  const visibleOverlay = computed(() =>
    overlayComponents.value.find(({ isVisible }) => isVisible),
  )

  return {
    overlayComponents,
    visibleOverlay,
  }
}
